module.exports = ".modal-xl-lg {\n  max-width: 80%;\n  min-width: 800px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/reporte-resumen-de-obra/reporte-resumen-de-obra-grupos-modal/reporte-resumen-de-obra-grupos-modal.component.scss
// module id = ./src/app/components/reporte-resumen-de-obra/reporte-resumen-de-obra-grupos-modal/reporte-resumen-de-obra-grupos-modal.component.scss
// module chunks = main